export class SharedValues {
  static localization: any;

  static getLocalizationValue(
    key: string,
    defaultValue: string | null = null
  ): string {
    return (
      (SharedValues.localization && SharedValues.localization[key]) || defaultValue || key
    );
  }
}
